import { IInquiryDetails, TInquiryStatus } from '@interfaces/inquiries';
import { IMedicationInquiry } from '@interfaces/medications';
import { ISupplementInquiry } from '@interfaces/supplements';

export class InquiryDetails {
  createdOn: string;

  id: number;

  inquiryItems: IMedicationInquiry[] | ISupplementInquiry[];

  inquiryStatusId: TInquiryStatus;

  isSupplementary: boolean;

  medicationInquiriesDto: IMedicationInquiry[];

  name: string;

  supplementInquiriesDto: ISupplementInquiry[];

  constructor(dto: IInquiryDetails) {
    const data: IInquiryDetails = dto && typeof dto === 'object' ? dto : ({} as IInquiryDetails);
    this.id = data.id;
    this.name = data.name || '';
    this.inquiryStatusId = data.inquiryStatusId || null;
    this.createdOn = data.createdOn || '';
    this.supplementInquiriesDto = Array.isArray(data.supplementInquiriesDto)
      ? data.supplementInquiriesDto
      : [];
    this.medicationInquiriesDto = Array.isArray(data.medicationInquiriesDto)
      ? data.medicationInquiriesDto
      : [];
    this.isSupplementary = Boolean(this.supplementInquiriesDto.length);
    if (this.isSupplementary) {
      this.inquiryItems = this.supplementInquiriesDto;
    } else {
      this.inquiryItems = this.medicationInquiriesDto;
    }
  }
}
